module.exports = __webpack_public_path__ + "a43c0a3f4fa0be240314c3d105fbd3ba.MP3";